import React from 'react';

 const TaskStatusPieChart = ({ pending, inProgress, completed, size = 150 }) => {
  // Define colors
  const PENDING_COLOR = '#EF4444'; // Red-500
  const IN_PROGRESS_COLOR = '#F59E0B'; // Yellow-500
  const COMPLETED_COLOR = '#22c55e'; // Green-500

  const total = pending + inProgress + completed;
  const center = size / 2;
  const radius = center * 0.8; // Increased radius to fill more space

  // Convert degrees to radians
  const toRadians = (deg) => (Math.PI / 180) * deg;

  // Helper function to create arc path
  const createArc = (startAngle, angle) => {
    const endAngle = startAngle + angle;
    const startX = center + radius * Math.cos(toRadians(startAngle));
    const startY = center + radius * Math.sin(toRadians(startAngle));
    const endX = center + radius * Math.cos(toRadians(endAngle));
    const endY = center + radius * Math.sin(toRadians(endAngle));
    const largeArcFlag = angle > 180 ? 1 : 0;

    return `
      M ${center} ${center}
      L ${startX} ${startY}
      A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY}
      Z
    `;
  };

  let startAngle = 0;
  const pendingAngle = total ? (pending / total) * 360 : 0;
  const inProgressAngle = total ? (inProgress / total) * 360 : 0;
  const completedAngle = total ? (completed / total) * 360 : 0;

  const pendingPath = createArc(startAngle, pendingAngle);
  startAngle += pendingAngle;

  const inProgressPath = createArc(startAngle, inProgressAngle);
  startAngle += inProgressAngle;

  const completedPath = createArc(startAngle, completedAngle);

  const innerCircleRadius = radius * 0.8; // Reduced inner circle radius

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="mx-auto">
      {/* Slices */}
      {pending > 0 && <path d={pendingPath} fill={PENDING_COLOR} />}
      {inProgress > 0 && <path d={inProgressPath} fill={IN_PROGRESS_COLOR} />}
      {completed > 0 && <path d={completedPath} fill={COMPLETED_COLOR} />}
      {/* Center circle to create the "donut" effect */}
      <circle cx={center} cy={center} r={innerCircleRadius} fill="#1e1e1e" />
      {/* Text */}
      <text
        x={center}
        y={center + 5}
        textAnchor="middle"
        fill="#fff"
        fontSize={size * 0.12}
        fontWeight="bold"
        fontFamily="Arial, sans-serif"
      >
        {total}
      </text>
      <text
        x={center}
        y={center + size * 0.13 + (size * 0.04)}
        textAnchor="middle"
        fill="#aaa"
        fontSize={size * 0.06}
        fontFamily="Arial, sans-serif"
      >
        TOTAL
      </text>
    </svg>
  );
};

export default TaskStatusPieChart;